import React from 'react';
import {Field} from 'react-final-form';


const Subject = (props) => {

  return (
    <Field name="subject" validate={props.required}>
    {({ input, meta }) => (
      <div className="subject">
        <input {...input} type="text" placeholder="Onderwerp" />
        {meta.error && meta.touched && !meta.active && <span className="error">{meta.error}</span>}
      </div>
    )}
  </Field>

  );
};

export default Subject;
